export default __webpack_public_path__ + "static/media/WNo.6-0.8cd2e5b7.jpg";